import Vue from 'vue'

import * as msal from '@azure/msal-browser'

let msalInstance = null

const MsalPlugin = {
  tokenExpirationTimers: {},

  data: {
    get accessToken () { return this.scopes[Object.keys(this.scopes).find(k => k.startsWith('api'))]?.accessToken },
    get graphToken () { return this.scopes[Object.keys(this.scopes).find(k => k.includes('User.Read'))]?.accessToken },
    account: null,
    scopes: {},
    isMocked: false
  },

  async install (vue, options) {
    if (!options) {
      throw new Error('Plugin options must be specified')
    }
    // TODO: Implement merging with defaults
    this.pluginOptions = options
    this.initialize(this.pluginOptions)

    vue.prototype.$msal = Vue.observable(this)

    vue.mixin({
      data () {
        return {
          auth: (this.$msal) ? this.$msal.data : {}
        }
      },

      created: function () {
        this.$watch('$msal.data', (value) => { this.auth = value }, { deep: true })
      },

      computed: {
        isAuthenticated () {
          return this.$msal.isAuthenticated()
        }
      }
    })
  },

  initialize (options) {
    const msalConfig = {
      auth: {
        clientId: options.clientId,
        authority: options.commonAuthority,
        knownAuthorities: [options.commonAuthority],
        redirectUri: options.redirectUri
      },
      system: {
        loggerOptions: {
          loggerCallback: (level, message) => {
            switch (level) {
              case msal.LogLevel.Error:
                console.error(message)
                return
              case msal.LogLevel.Info:
                console.info(message)
                return
              case msal.LogLevel.Verbose:
                console.debug(message)
                return
              case msal.LogLevel.Warning:
                console.warn(message)
            }
          },
          logLevel: options.logLevel
        }
      }
    }
    if (options.mock) {
      this.data.account = options.mock.account
      this.data.accessToken = options.mock.accessToken
      this.data.isMocked = true
    }
    msalInstance = new msal.PublicClientApplication(msalConfig)
  },

  async signIn () {
    if (!this.data.isMocked) {
      return msalInstance.handleRedirectPromise()
        .then((authResponse) => {
          if (authResponse) {
            const { accessToken, expiresOn, scopes } = authResponse
            this.setToken(accessToken, expiresOn, scopes)
          } else {
            const currentAccounts = msalInstance.getAllAccounts()

            if (currentAccounts.length === 0) {
              const loginRequest = {
                scopes: [this.pluginOptions.defaultScopes]
              }
              msalInstance.loginRedirect(loginRequest)
            }
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  },

  async signOut () {
    await msalInstance.logout()
  },

  async acquireToken (scopes = [this.pluginOptions.defaultScopes]) {
    const request = {
      account: msalInstance.getAllAccounts()[0],
      scopes: [...scopes]
    }
    try {
      const { accessToken, expiresOn, scopes } = await msalInstance.acquireTokenSilent(request)
      this.setToken(accessToken, expiresOn, scopes)
      return accessToken
    } catch (error) {
      if (error instanceof msal.InteractionRequiredAuthError) {
        msalInstance.acquireTokenRedirect(request)
      }
      return false
    }
  },

  setToken (accessToken, expiresOn, scopes) {
    const expirationOffset = 100 * 1000
    const expiration = expiresOn.getTime() - (new Date()).getTime() - expirationOffset
    const scopesKey = scopes.join()
    if (expiration >= 0) {
      this.data.scopes[scopesKey] = { accessToken, expiresOn }
      this.data.account = msalInstance.getAllAccounts()[0]

      if (this.tokenExpirationTimers[scopesKey]) clearTimeout(this.tokenExpirationTimers[scopesKey])
      this.tokenExpirationTimers[scopesKey] = window.setTimeout(async () => {
        console.log('auto refreshing token: ', scopesKey)
        await this.acquireToken(scopesKey.split(','))
      }, expiration)
    }
  },

  isAuthenticated () {
    const accounts = msalInstance.getAllAccounts()
    return accounts && accounts.length > 0
  }
}

export default MsalPlugin
export const authContext = MsalPlugin.data
